import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { selectLocation } from 'store/Router/selectors';
import { redirect } from 'store/Router/actions';
import Text from './styled';

const formatName = (name) => {
  if (name !== 'Runners & Security Scanners') return name;
  return <span>Runners &<br />Security Scanners</span>;
};

const SubPage = ({ name, url, enabledByFeature, FF, showFF }) => {
  const dispatch = useDispatch();
  const location = useSelector(selectLocation);
  const isSelected = (loc) => location.pathname === loc;

  const onClick = () => {
    if (enabledByFeature) dispatch(redirect(url));
    else showFF(FF);
  };

  return <Text onClick={ onClick } selected={ isSelected(url) } title={ name }>{ formatName(name) }</Text>;
};

SubPage.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default SubPage;
